import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import {Card} from "material-ui/Card/index";
import ViewTitle from "components/layout/ViewTitle";
import FlatButton from "material-ui/FlatButton/index";
import { CardActions } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import { NavigationArrowBack } from 'material-ui/svg-icons/';
import Table from 'material-ui/Table/Table';
import TableBody from 'material-ui/Table/TableBody';
import TableRowColumn from 'material-ui/Table/TableRowColumn';
import TableHeader from 'material-ui/Table/TableHeader';
import TableRow from 'material-ui/Table/TableRow';

import * as utils from "./utils";
import {
  updateSwitchFunctionWhitelist as updateSwitchFunctionWhitelistAction,
  clearStateUpdateSwitchFunctionWhitelist as clearStateUpdateSwitchFunctionWhitelistAction,
} from "actions/advancedFunction";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};

class FunctionSwitchEditWhitelist extends Component {

  constructor(props) {
    super(props);
    this.initState();
    this.goBack = this.goBack.bind(this);
    this.save = this.save.bind(this);
    this.getLocalShopInfo = this.getLocalShopInfo.bind(this);
  }

  initState() {
    this.state = {
      shopMerchantIdMap: {},
    };
  }

  componentDidMount() {
  }

  goBack() {
    this.props.history.goBack();
  }

  save(shopCheckedData) {
    const feature = this.props.match.params.feature;
    const shopData = shopCheckedData.map((shop)=>{
      const merchantId = this.state.shopMerchantIdMap[shop.shop_id] !== undefined ? this.state.shopMerchantIdMap[shop.shop_id] : shop.merchant_id;
      return {
        shop_id: shop.shop_id,
        merchant_id: merchantId
      }
    });
    let shopIdAddToWhitelist = [];
    for (const shop of shopCheckedData) {
      shopIdAddToWhitelist.push(shop.shop_id);
    }
    let data = { 
      shop_feature_setting_packs: [{
        shops: shopData,
        shop_feature_setting: {
          field: feature,
          value: utils.SHOP_ID_IN_WHITELIST
        },
      }]
    };
    this.props.updateSwitchFunctionWhitelist(data);
  }


  getLocalShopInfo() {
    const shopData = JSON.parse(localStorage.getItem(utils.localStoreKeyForShopDataPrepareEdit));
    if (shopData) {
      let shopList = [shopData];
      return shopList.map((item)=>{
        const {shop} = item;
        return {
          shop_id: shop.shop_id,
          owner_mobile_number: shop.shop_info.owner_mobile_number,
          shop_name: shop.shop_info.shop_name,
          merchant_id: shop.shop_info.merchant_id
        }
      });
    }
    return [];
  }

  render() {
    const feature = parseInt(this.props.match.params.feature, 10);
    const { updateWhitelistSuccess } = this.props;
    if (updateWhitelistSuccess) {
      this.props.clearStateUpdateSwitchFunctionWhitelist();
      this.goBack();
    }
    const featureName = localStorage.getItem(utils.localStoreKeyForCurrentFeatureName);
    const shopList = this.getLocalShopInfo();
    let isCanSave = shopList.length > 0;
    if(feature === utils.E_PAYMENT_FEATURE_ID) {
      (shopList || []).forEach((shop) => {
        const merchantId = this.state.shopMerchantIdMap[shop.shop_id] !== undefined ? this.state.shopMerchantIdMap[shop.shop_id] : shop.merchant_id;
        if(!merchantId) {
          isCanSave = false;
        }
      });
    }
    

    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} } >
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title= {`Edit Shop - ${featureName}`}/>
        
          <div>
            <Table>
              <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                <TableRow >
                  <TableRowColumn>Shop ID</TableRowColumn>
                  { feature === utils.E_PAYMENT_FEATURE_ID ? <TableRowColumn>Merchant Id</TableRowColumn> : null }
                  <TableRowColumn>Owner mobile</TableRowColumn>
                  <TableRowColumn>Shop name</TableRowColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {
                  shopList.map( shop => (
                    <TableRow key={shop.shop_id} selectable={false}>
                      <TableRowColumn>{shop.shop_id}</TableRowColumn>
                      { feature === utils.E_PAYMENT_FEATURE_ID ?
                      <TableRowColumn>
                        <TextField
                          id={"merchant_id_input" + shop.shop_id}
                          onChange={(event, newValue) => {
                            const inputMerchantId = newValue.trim();
                            this.setState({
                              shopMerchantIdMap: {
                                ...this.state.shopMerchantIdMap,
                                [shop.shop_id]: inputMerchantId,
                              }
                            });
                          }}
                          hintStyle={{color: '#ccc'}}
                          placeholder="Merchant ID"
                          defaultValue={shop.merchant_id}
                          value={this.state.shopMerchantIdMap[shop.shop_id]}
                          maxLength={utils.MaxMerchantIdLength}
                          rows={1}
                          multiLine={false}
                        />
                      </TableRowColumn> : null }
                      <TableRowColumn>{shop.owner_mobile_number}</TableRowColumn>
                      <TableRowColumn>{shop.shop_name}</TableRowColumn>
                    </TableRow>
                  ))
                }
              </TableBody>
            </Table>
          </div>
             
          <br />
          <FlatButton
            primary
            label='Save'
            disabled={!isCanSave}
            onClick={ () => this.save(shopList) }
            style={{
              margin: '5px 12px',
              position: 'relative',
            }}
          />
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    updateWhitelistSuccess: state.admin.advancedFunction.updateWhitelistSuccess,
  };
}

export default connect(
  mapStateToProps,
  {
    updateSwitchFunctionWhitelist: updateSwitchFunctionWhitelistAction,
    clearStateUpdateSwitchFunctionWhitelist: clearStateUpdateSwitchFunctionWhitelistAction,
  }
)(FunctionSwitchEditWhitelist);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/FunctionSwitchEditWhitelist.js